import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"

export const ExclamationTriangle = (props) => {
  return <FontAwesomeIcon faIcon={faExclamationTriangle} {...props} />
}
